export const PREVIOUS_NOTES_SUPPORTED_EXTENSIONS = [
  "pdf",
  "docx",
  "doc",
  "xlsx",
  "xls",
  "txt",
] as const;
